import React from 'react';

const testimonials = [
  {
    name: 'Samantha R.',
    quote: 'BantrBox turned my daily routine into a fun series of mini-challenges!',
  },
  {
    name: 'Marcus D.',
    quote: 'Every challenge motivates me to go beyond my comfort zone—love it!',
  },
  {
    name: 'Jada P.',
    quote: 'I’ve never had this much fun pushing friends to achieve their goals.',
  },
  {
    name: 'Carlos B.',
    quote: 'The supportive community is the best part. Everyone’s cheering each other on!',
  },
  {
    name: 'Linda T.',
    quote: 'It’s a spark of excitement in my week, and I never get bored.',
  },
  {
    name: 'Adam S.',
    quote: 'Finally tackled my bucket list—who knew healthy rivalries could be this fun?',
  },
  {
    name: 'Priya K.',
    quote: 'Perfect platform for friendly competitions. Keeps me inspired!',
  },
  {
    name: 'Theo L.',
    quote: 'Our group challenges are a highlight of my week—pure positive energy.',
  },
  {
    name: 'Jasmine W.',
    quote: 'I love seeing friends succeed. It’s so uplifting to share these challenges together!',
  },
  {
    name: 'Daniel G.',
    quote: 'BantrBox gave me that extra push to accomplish things I’d been putting off for years.',
  },
];

const TestimonialsSection = () => {
  // Duplicate the testimonials for seamless looping.
  const scrollingTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-[#333] text-center mb-10">
          What Our Users Say
        </h2>

        {/* The outer container hides overflow (no visible scrollbar). */}
        <div className="relative w-full overflow-hidden">
          {/* The inner container is twice as wide and moves left with keyframes. */}
          <div className="flex w-[200%] animate-marquee">
            {scrollingTestimonials.map((test, i) => (
              <div
                key={i}
                className="bg-[#F5F5F5] p-6 rounded-lg shadow text-center flex flex-col items-center 
                           min-w-[300px] mx-2 my-4"
              >
                <p className="text-[#666] italic mb-4">
                  “{test.quote}”
                </p>
                <h4 className="font-semibold text-[#333]">
                  {test.name}
                </h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
